import { useState } from 'react';
import { FolderPlus } from 'lucide-react';
import type { DecisionDetail } from '@hector/shared-types';
import { cn } from '@/lib/utils';
import { SaveDecisionDialog } from '@/components/case/jurisprudence/SaveDecisionDialog';

/**
 * Bouton « Enregistrer » d'une décision — action de la CHROME (panneau / page),
 * au même titre que « Télécharger », et distincte du document `DecisionView`.
 *
 * Il ouvre le dialog de destination ; tout le travail (rendu, upload, création de
 * la pièce, traitement IA) vit dans `SaveDecisionDialog`.
 */
export function SaveDecisionButton({
  decision,
  caseId,
  className,
}: {
  decision: DecisionDetail;
  /** Dossier actif, pré-sélectionné dans le dialog quand il y en a un. */
  caseId?: string;
  className?: string;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={cn(
          'inline-flex items-center gap-1.5 rounded-md border border-grey-200 px-2.5 py-1 text-xs font-medium text-charcoal transition-colors hover:bg-grey-50',
          className,
        )}
      >
        <FolderPlus className="h-3.5 w-3.5" />
        <span>Enregistrer</span>
      </button>
      <SaveDecisionDialog
        open={open}
        onOpenChange={setOpen}
        decision={decision}
        preselectedCaseId={caseId}
      />
    </>
  );
}
